import React from "react"

import "./style.scss"

type BackofficePageProps = {
  eyebrow: string
  title: string
  description?: string
  icon?: string
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
}

type BackofficePanelProps = {
  title?: string
  description?: string
  icon?: string
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
}

type BackofficeEmptyStateProps = {
  title: string
  description: string
  icon?: string
  action?: React.ReactNode
}

export const BackofficePage = ({eyebrow, title, description, icon = "fa-sliders-h", actions, children, className = ""}: BackofficePageProps) => {
  return <main className={`backoffice-page ${className}`.trim()}>
    <header className="bo-page-hero">
      <div className="bo-page-heading">
        <span className={`bo-page-icon fas ${icon}`} aria-hidden="true"></span>
        <div>
          <span className="bo-eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
      </div>
      {actions && <div className="bo-page-actions">{actions}</div>}
    </header>
    <div className="bo-page-content">{children}</div>
  </main>
}

export const BackofficePanel = ({title, description, icon, actions, children, className = ""}: BackofficePanelProps) => {
  return <section className={`bo-panel ${className}`.trim()}>
    {(title || description || actions) && <header className="bo-panel-header">
      <div className="bo-panel-heading">
        {icon && <span className={`bo-panel-icon fas ${icon}`} aria-hidden="true"></span>}
        <div>
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
        </div>
      </div>
      {actions && <div className="bo-panel-actions">{actions}</div>}
    </header>}
    <div className="bo-panel-body">{children}</div>
  </section>
}

export const BackofficeEmptyState = ({title, description, icon = "fa-inbox", action}: BackofficeEmptyStateProps) => {
  return <div className="bo-empty-state">
    <span className={`fas ${icon}`} aria-hidden="true"></span>
    <strong>{title}</strong>
    <p>{description}</p>
    {action}
  </div>
}
